import axios from 'axios';
import { attachRequestId } from './requestId';

const api = axios.create({
  baseURL: process.env.REACT_APP_PROGRAMS_API || 'https://programs.afinidata.com/api/0.1',
});

attachRequestId(api);

// Interceptor to add token from localStorage
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // use memory-based manager if needed
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const conseguirGrupos = async (year?: number) => {
    const params: Record<string, string> = {};
    if (year !== undefined && year !== null) params.year = String(year);
    const response = await api.get('/user_group', { params });
    return response.data
};

export const conseguirAniosDisponibles = async () => {
    const response = await api.get('/user_group/years/');
    return response.data
};


export const conseguirNinos = async (children: string) => {
    const response = await api.get(`/user_group/${children}/children/?all=true`);
    return response.data
};


export const ConseguirPrograma = async (group: string, child: string) => {
    const response = await api.get(`/user_group/instance_data/${group}/${child}`);
    return response.data
};

export const conseguirReporteGrupo = async (groupId: string) => {
    const response = await api.get(`/user_group/${groupId}/group_report/`);
    return response.data
};

export default api;

